import AuthorizedAxiosInstance from 'libs/axios/AuthorizedAxiosInstance'

export const getRequests = async () =>
	await AuthorizedAxiosInstance.get('/conversations/request')

export const deleteRequestById = async conversationId =>
	await AuthorizedAxiosInstance.delete(
		`/conversations/request/${conversationId}`
	)
